import { PixelCrop } from 'react-image-crop';
import { createEvent, createStore } from 'effector';
import { ImageTabs, ImageType, UploadSettings } from '@nx-frontend/shared/types';
import { CropSize, patchObject } from '@nx-frontend/shared/utils';

export interface ImageSelectorState {
  tabs: ImageTabs[];
  activeTab: ImageType;
  file: File | undefined;
  completedCrop: PixelCrop | undefined;
  cropImage: string;
  previewImage: string;
  previewImageError: boolean;
  previewEmoji: string;
  previewIcon: string;
  uploadSettings: UploadSettings;
  cropSize?: CropSize;
}

export const initialImageSelectorState: ImageSelectorState = {
  tabs: [
    {
      type: ImageType.EMOJI,
      active: true,
      name: 'Emojis',
    },
    {
      type: ImageType.ICON,
      active: true,
      name: 'Icons',
    },
    {
      type: ImageType.URL,
      active: true,
      name: 'Image',
    },
  ],
  activeTab: ImageType.URL,
  file: undefined,
  completedCrop: undefined,
  cropImage: '',
  previewImage: '',
  previewImageError: false,
  previewEmoji: '',
  previewIcon: '',
  uploadSettings: {
    workspaceId: '',
    target: '',
    targetId: '',
    groupId: '',
    sessionId: null,
  },
  cropSize: undefined,
};

export const updateImageSelectorEvent = createEvent<Partial<ImageSelectorState>>();
export const updateTabsEvent = createEvent<ImageTabs[]>();
export const setUploadSettingsEvent = createEvent<UploadSettings>();
export const setActiveTabEvent = createEvent<ImageType>();
export const resetImageSelectorEvent = createEvent();

export const $imageSelector = createStore<ImageSelectorState>(initialImageSelectorState)
  .on(updateImageSelectorEvent, (state, params) => {
    if (params.file) {
      params.previewImage = URL.createObjectURL(params.file);
    }
    return { ...state, ...params };
  })
  .on(updateTabsEvent, (state, tabs) => {
    const patchedTabs = state.tabs.map((item) => {
      const patchItem = tabs.find((patch) => {
        return item.type === patch.type;
      });
      return patchItem ? patchObject(item, patchItem) : item;
    });
    return {
      ...state,
      tabs: patchedTabs,
    };
  })
  .on(setActiveTabEvent, (state, activeTab) => {
    const resetData = {
      previewEmoji: '',
      previewIcon: '',
      previewImage: '',
    };
    return { ...state, activeTab, ...resetData };
  })
  .on(setUploadSettingsEvent, (state, uploadSettings) => {
    return { ...state, uploadSettings };
  })
  .reset(resetImageSelectorEvent);

export const $imageSelectorTabs = $imageSelector.map((state) => state.tabs);
export const $imageSelectorActiveTab = $imageSelector.map((state) => state.activeTab);
export const $imageSelectorUploadSettings = $imageSelector.map((state) => state.uploadSettings);
export const $imageSelectorFile = $imageSelector.map((state) => state.file);
